define('lib/util/map.static',[
  'jquery',
  'lib/services/batws'
], function (
  $,
  batws
) {

  /*------------------------------------------------------------------------
  Promise obj to get a signed map from google.
  PLEASE REWRITE ME!! (BK)
  returns a string for use in img src

  Use /BATWS/map/key service to get a signed img from Google Maps. Needs to be signed in order to request a very large img
  Returns a URL to then be used in img src
  map styleString attached to BAT25-58 and/or created/edited via: https://mapstyle.withgoogle.com/

  accepts an options object which defaults to a zoomed out view of USA.
  recommended options for zoomed in maps:
  zoom: 11,
  location: currentZip, 'USA', 'lat,lon'
  markers: boolean, show a custom marker img
  ------------------------------------------------------------------------*/
  return function (options) {
    // if no options obj is supplied, use these defaults
    var settings = Object.assign({
      size: '1660x540',
      zoom: 5,
      location: 'USA',
      markers: false,
      scale: 2
    }, options);

    // var styleString = '&format=png&maptype=roadmap&style=element:geometry.fill%7Ccolor:0xf1f1f2&style=feature:administrative.land_parcel%7Celement:labels%7Cvisibility:off&style=feature:landscape.man_made%7Celement:geometry.fill%7Ccolor:0xf1f1f2&style=feature:landscape.natural%7Celement:geometry.fill%7Ccolor:0xf1f1f2&style=feature:poi%7Celement:labels%7Cvisibility:off&style=feature:poi%7Celement:labels.text%7Cvisibility:off&style=feature:poi.park%7Celement:geometry.fill%7Ccolor:0xf1f1f2&style=feature:road%7Celement:geometry.fill%7Ccolor:0xffffff&style=feature:road.arterial%7Celement:labels%7Cvisibility:off&style=feature:road.highway%7Celement:geometry.fill%7Ccolor:0xdadada&style=feature:road.highway%7Celement:geometry.stroke%7Cvisibility:off&style=feature:road.local%7Celement:labels%7Cvisibility:off&style=feature:transit%7Celement:labels%7Cvisibility:off&style=feature:water%7Celement:geometry.fill%7Ccolor:0xc2cee5';
    var query = {
      center: settings.location,
      size: settings.size,
      scale: settings.scale,
      zoom: settings.zoom,
    };

    if (settings.markers) {
      query.markers = 'scale:2|icon:https://buyatoyota.com/assets/img/maps/marker@2x.png|' + settings.location;
    }
    return batws.map().static({
      query: $.param(query)
    });
  };
});

